/**
 * Схема и сериализация `ai.llm_providers.config` (согласовано с backend LlmProviderRuntimeConfig).
 */

import { z } from "zod";

/** Валидация значений для формы админки (совпадает с Pydantic на сервере). */
export const llmProviderRuntimeConfigSchema = z
  .object({
    temperature: z.number().min(0).max(2).optional(),
    max_tokens: z.number().int().min(1).max(1_000_000).optional(),
    top_p: z.number().min(0).max(1).optional(),
    frequency_penalty: z.number().min(-2).max(2).optional(),
    presence_penalty: z.number().min(-2).max(2).optional(),
    stop: z.array(z.string()).optional(),
    tool_choice: z.enum(["auto", "required", "none"]).optional(),
    timeout_seconds: z.number().int().min(1).max(600).optional(),
    max_retries: z.number().int().min(0).max(20).optional(),
    retry_delay_seconds: z.number().min(0).max(120).optional(),
    retry_backoff_multiplier: z.number().min(1).max(10).optional(),
    extra_headers: z.record(z.string()).optional(),
    max_concurrent_requests: z.number().int().min(1).max(10_000).optional(),
    rate_limit_rpm: z.number().int().min(1).optional(),
    rate_limit_tpm: z.number().int().min(1).optional(),
    enable_request_logging: z.boolean().optional(),
    log_full_message_bodies: z.boolean().optional(),
    /** omit | redact | full (+ legacy: mask, metadata → omit) — см. backend summarize_messages_for_log */
    pii_redaction_mode: z.string().max(64).optional(),
    /** OpenTelemetry span llm.chat_completions (без промптов в атрибутах) */
    enable_tracing: z.boolean().optional(),
    cost_per_1k_input_tokens: z.number().min(0).optional(),
    cost_per_1k_output_tokens: z.number().min(0).optional(),
    passthrough_params: z.record(z.unknown()).optional(),
    schema_version: z.number().int().min(1).max(1000).optional(),
  })
  .passthrough();

export type LlmProviderRuntimeConfigForm = z.infer<typeof llmProviderRuntimeConfigSchema>;

/** Убирает undefined/null и пустые массивы stop для компактного JSON. */
export function compactRuntimeConfig(
  c: Record<string, unknown>,
): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  for (const [k, v] of Object.entries(c)) {
    if (v === undefined || v === null) continue;
    if (k === "stop" && Array.isArray(v) && v.length === 0) continue;
    out[k] = v;
  }
  return out;
}
